import { combineReducers } from '@reduxjs/toolkit';
import { entriesReducer } from "./entries";
import { sheetsReducer } from "./sheets";
import { sectionsReducer } from "./sections";
import { appReducer } from "./app";
import { conditionsReducer } from "./conditions";
import { operationsReducer } from "./operations";
import { referenceDataReducer } from "./refrenceData";
export const reducers = {
  conditions: conditionsReducer,
  operations: operationsReducer,
  referenceData: referenceDataReducer,
  entries: entriesReducer,
  sheets: sheetsReducer,
  sections: sectionsReducer,
  app: appReducer
};
export const entitiesReducer = combineReducers(reducers);